<!-- src/views/OfficerGroupMembersView.vue -->
<template>
    <div class="container-fluid p-4">

        <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
            <h1 class="page-title fw-normal text-secondary mb-0">Officer Group ({{group.groupName || '...'}})</h1>
            <div class="d-flex gap-2">
                <button type="button" class="btn btn-success" @click="ShowAssignStaffModal()">ASSIGN STAFF</button>
                <button type="button" class="btn btn-primary" @click="goBack()">BACK</button>
            </div>
        </div>

        <span v-if="isDataFetched" class="d-flex justify-content-center">
            <div class="spinner-border text-primary">
                <span class="visually-hidden"></span>
            </div>
             Loading...
        </span>

        <div class="card shadow-sm">
            <div class="card-body p-0">
                <div class="table-responsive">
                    <table class="table text-left table-hover mb-0 align-middle members-table">
                        <thead>
                            <tr class="table-light">
                                <th>PIN</th>
                                <th>Forename</th>
                                <th>Surname</th>
                                <th>Contact</th>
                                <th>SIA</th>
                                <th>Expiry</th>
                                <th>Type</th>
                                <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="member in members" :key="member.securityOfficerId" class="member-row" title="Double-click to view jobs calendar" @dblclick="ShowJobsCalendar(member)">
                                <td>{{member.securityOfficerId}}</td>
                                <td>{{member.firstName}}</td>
                                <td>{{member.lastName}}</td>
                                <td>{{member.mobileNumber || "-"}}</td>
                                <td>{{member.siabadageNumber || "-"}}</td>
                                <td>{{formatDate(member.siaExpiryDate)}}</td>
                                <td>{{member.designationName || "-"}}</td>
                                <td class="text-end">
                                    <button type="button" class="btn btn-primary action-btn me-2" title="View jobs calendar" @click.stop="ShowJobsCalendar(member)" @dblclick.stop>
                                        <i class="bi bi-calendar3"></i>
                                    </button>
                                    <button type="button" class="btn btn-danger action-btn" title="Remove from group" @click.stop="RemoveMember(member)" @dblclick.stop>
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="!isDataFetched && members.length === 0">
                                <td colspan="8" class="text-center text-muted py-3">No officers assigned to this group yet</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <OfficerJobsCalendarPopup
            v-if="calendarOfficer"
            :base-url="baseUrl"
            :officer-id="calendarOfficer.securityOfficerId"
            :officer-name="`${calendarOfficer.firstName} ${calendarOfficer.lastName}`"
            @close="calendarOfficer = null"
        />

        <button type="button" class="btn btn-primary collapse" id="assignStaffModalButton" data-bs-toggle="modal" data-bs-target="#assignStaffModal">
        Launch assignStaffModal
        </button>

        <div class="modal" id="assignStaffModal" tabindex="999999">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-align-center text-primary fw-bold">Assign Staff</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row p-2 m-2 modal-body text-left">
                            <Multiselect
                                v-model="selectedOfficerIds"
                                mode="tags"
                                :close-on-select="false"
                                :searchable="true"
                                :options="officers.map(o => ({ value: o.id, label: o.name }))"
                                placeholder="Select officers..."
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" @click="SaveAssignedStaff()" class="btn btn-secondary" data-bs-dismiss="modal">Save</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import OfficerJobsCalendarPopup from '@/components/OfficerJobsCalendarPopup.vue'

export default({
name:'OfficerGroupMembersView',
components: { Multiselect, OfficerJobsCalendarPopup },
props:{
    baseUrl:String,
    groupId:Number
},
data() {
    return {
        group:{},
        members:[],
        officers:[],
        isDataFetched:false,
        selectedOfficerIds:[],
        calendarOfficer:null
    }
},
methods:{
    loadOfficersFromLookupData(){
        const cachedData = localStorage.getItem("lookupData");
        if (!cachedData) return;
        const data = JSON.parse(cachedData);
        this.officers = (data.officers || []).map(o => ({ id: o.id, name: o.name }));
    },
    formatDate(dateStr){
        if(!dateStr) return "-";
        const d = new Date(dateStr);
        return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`;
    },
    getGroup(){
        let groupsRequestUrl = this.baseUrl + "OfficerGroups/GetAll";
        let groupsRequestOptions = {
            method:"GET",
            headers:{
              "Authorization":"Bearer " + localStorage.token,
              "Content-Type" : "application/json"
            },
          };

          return fetch(groupsRequestUrl, groupsRequestOptions)
          .then(response => response.json())
          .then(res =>{
            this.group = (res.groups || []).find(g => g.officerGroupId === this.groupId) || {};
          })
          .catch(error=>{
            console.log("error encountered", error);
          });
    },
    getMembers(){
        let membersRequestUrl = this.baseUrl + "OfficerGroups/GetMembers?officerGroupId=" + this.groupId;
        let membersRequestOptions = {
            method:"GET",
            headers:{
              "Authorization":"Bearer " + localStorage.token,
              "Content-Type" : "application/json"
            },
          };

          return fetch(membersRequestUrl, membersRequestOptions)
          .then(response => response.json())
          .then(res =>{
            this.members = res.members || [];
          })
          .catch(error=>{
            console.log("error encountered", error);
          });
    },
    loadGroupAndMembers(){
        this.isDataFetched = true;
        Promise.all([this.getGroup(), this.getMembers()])
            .finally(() => { this.isDataFetched = false; });
    },
    saveGroupOfficerIds(officerIds){
        let updateGroupRequestUrl = this.baseUrl + "OfficerGroups/Update";
        let updateGroupRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "officerGroupId" : this.group.officerGroupId,
                    "groupName": this.group.groupName,
                    "isActive": this.group.isActive,
                    "branchId": this.group.branchId,
                    "officerIds": officerIds
                }
            )
        };

        return fetch(updateGroupRequestUrl, updateGroupRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                await this.loadGroupAndMembers();
            }
            else{
                alert("Failed to update group. Please try again.");
                console.error("Update error:", result);
            }
        })
        .catch(error=>{
            console.error("Update failed:", error);
            alert("An error occurred while updating the group.");
        });
    },
    ShowAssignStaffModal(){
        this.selectedOfficerIds = [...(this.group.officerIds || [])];
        document.getElementById("assignStaffModalButton").click();
    },
    SaveAssignedStaff(){
        this.saveGroupOfficerIds(this.selectedOfficerIds);
    },
    RemoveMember(member){
        if(!confirm(`Remove ${member.firstName} ${member.lastName} from this group?`)){
            return;
        }
        const officerIds = (this.group.officerIds || []).filter(id => id !== member.securityOfficerId);
        this.saveGroupOfficerIds(officerIds);
    },
    ShowJobsCalendar(member){
        this.calendarOfficer = member;
    },
    goBack(){
        this.$router.push("/officerGroups");
    }
},
mounted(){
    this.loadOfficersFromLookupData();
    this.loadGroupAndMembers();
},

})
</script>
<style scoped>
.page-title {
    font-size: 1.75rem;
}
.members-table {
    width: auto;
    min-width: 100%;
}
.members-table thead th {
    font-size: 1.05rem;
    font-weight: 600;
    color: #6c757d;
    padding: 0.75rem 1.25rem;
    white-space: nowrap;
}
.members-table tbody td {
    font-size: 1.05rem;
    padding: 0.75rem 1.25rem;
    white-space: nowrap;
}
.members-table td:last-child {
    width: 1%;
}
.member-row {
    cursor: pointer;
}
.action-btn {
    width: 2.375rem;
    height: 2.375rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}
</style>
